/*
    i18n - nice to know:
    - vee-validate/i18n does not work with YUP
          https://github.com/logaretm/vee-validate/issues/4627
    - yup-locale
        uses translations for default rules: https://github.com/skress/yup-locale-de/blob/master/localeDE.js
        e.g. required: '${path} ist ein Pflichtfeld',
        path contains <Field name="content"> but can be changed using required.label("Beschreibung")
 */

import * as Yup from "yup"
import { PhoneNumberUtil } from 'google-libphonenumber'
import {de} from 'yup-locales'
import {hasHttpUrlPrefix, normalizeHttpUrl} from '@/utils/httpUrl'

export {normalizeHttpUrl} from '@/utils/httpUrl'

const phoneUtil = PhoneNumberUtil.getInstance()
const CLDR_REGION_CODE_SIZE = 2

const isValidCountryCode = (countryCode) =>
  typeof countryCode === 'string' && countryCode.length === CLDR_REGION_CODE_SIZE

Yup.addMethod(Yup.string, 'phone', function yupPhone(countryCode, strict = false, errorMessage = '') {
  const errMsg =
    typeof errorMessage === 'string' && errorMessage
      ? errorMessage
      : isValidCountryCode(countryCode)
        ? `\${path} must be a valid phone number for region ${countryCode}`
        : '${path} must be a valid phone number.'

  return this.test('phone', errMsg, (value) => {
    if (!value) {
      return true
    }

    let region = countryCode
    let strictCheck = strict
    if (!isValidCountryCode(region)) {
      region = 'IN'
      strictCheck = false
    }

    try {
      const phoneNumber = phoneUtil.parseAndKeepRawInput(value, region)
      if (!phoneUtil.isPossibleNumber(phoneNumber)) {
        return false
      }

      if (!strictCheck) {
        return true
      }

      const regionCodeFromPhoneNumber = phoneUtil.getRegionCodeForNumber(phoneNumber)
      return phoneUtil.isValidNumberForRegion(phoneNumber, region || regionCodeFromPhoneNumber)
    } catch {
      return false
    }
  })
})

Yup.addMethod(Yup.string, 'httpUrl', function httpUrl() {
  return this
    .transform((value, originalValue) => normalizeHttpUrl(originalValue))
    .url()
    .test('http-protocol', '${path} muss eine gültige HTTP- oder HTTPS-URL sein.',
      value => !value || hasHttpUrlPrefix(value))
})

Yup.setLocale(de);
Yup.setLocale({
  mixed: {
    required: ({ label, path }) => {
      if(typeof label === 'undefined')  {
        const fallbackName = path.charAt(0).toUpperCase() + path.slice(1).replace(/_/g, ' ');
        return `${fallbackName} ist ein Pflichtfeld`;
      }
      return `${label} ist ein Pflichtfeld`;
    },
  },
});
export default Yup
